import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { accountTitle } from '../../ui/sections';
import { useAccountNav } from './useAccountNav';
type Props = {
  /** Zonder titel: de naam van de pagina uit het menu, zodat kop en menu altijd gelijk zijn. */
  title?: ReactNode;
  lead?: ReactNode;
  /** Actie rechts naast de titel (op mobiel eronder). */
  action?: ReactNode;
};

/** Dezelfde kop op elke pagina van Mijn omgeving, met een kruimelpad dat zegt waar je bent. */
export function PageTitle({
  title,
  lead,
  action
}: Props) {
  const {
    current,
    trail
  } = useAccountNav();
  return <header className="mb-8" data-id="element-6389" data-mp="3gjqkx5y9p6e3">
      {trail.length > 0 && current && <nav aria-label="Kruimelpad" className="mb-3" data-id="element-6390" data-mp="3kkitdwzbf79b">
          <ol className="flex flex-wrap items-center gap-1 text-[13px] text-muted" data-id="element-6391" data-mp="36jpy3a16w855">
            {trail.map(t => <li key={t.to} className="flex items-center gap-1" data-id="element-6392" data-mp="3bjcajh971kcw">
                <Link to={t.to} className="underline-offset-4 transition-colors duration-150 ease-soft hover:text-ink hover:underline" data-id="element-6393" data-mp="3bknh1ou0x67p">
                  {t.label}
                </Link>
                <ChevronRightIcon className="h-3.5 w-3.5" strokeWidth={1.5} aria-hidden="true" data-id="element-6394" data-mp="19lhrjfc5mxxr" />
              </li>)}
            <li aria-current="page" className="text-ink" data-id="element-6395" data-mp="1ikbj2ramoy4g">
              {current.short}
            </li>
          </ol>
        </nav>}
      <div className={action ? 'flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between' : ''} data-id="element-6396" data-mp="uvaitrby8ta9">
        <div className="min-w-0" data-id="element-6397" data-mp="qu708x2ioj5c">
          <h1 className={accountTitle} data-id="element-6398" data-mp="qr2pthygkr68">{title ?? current?.title}</h1>
          {lead && <p className="mt-3 max-w-xl text-[16px] leading-relaxed text-muted" data-id="element-6399" data-mp="14llllajwcwfk">{lead}</p>}
        </div>
        {action && <div className="shrink-0" data-id="element-6400" data-mp="zrhf0sejmqf0">{action}</div>}
      </div>
    </header>;
}